import React from 'react';
import './CoveragePeriod.css';
import TauriImage from '../../../TauriImage/TauriImage';

const statusMappingNames = {
  0: ["pending"],
  1: ["success"],
  2: ["missed"],
  3: ["inprogress"],
  4: ["recovered"],
  5: ["advanced"],
  8: ["jointcall", "success"],
  9: ["jointcall", "recovered"],
  10: ["jointcall", "advanced"]
};

const statusIcon = {
  "pending": "/Images/material-symbols--pending-actions.svg",
  "success": "/Images/material-symbols--check.svg",
  "missed": "/Images/akar-icons--person-cross.svg",
  "inprogress": "/Images/mdi--hourglass.svg",
  "recovered": "/Images/mdi--check-decagram.svg",
  "advanced": "/Images/material-symbols--check-advanced.svg",
  "jointcall": "/Images/mdi--handshake-outline.svg"
};

const CoveragePeriod = ({ data }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric"
    });
  };

  return (
    <div className="account-coverage-container">
      {(!data || data.length === 0) ? (
        <div className="no-coverage w-100 d-flex flex-column align-items-center justify-content-center py-4">
          <TauriImage localImage={"/Images/lucide--frown.svg"} alt="icon" />
          <div>No history of coverage yet</div>
        </div>
      ) : (
        data.map((period, idx) => (
          <div key={idx} className="coverage-period">
            <div className="period-header">
              <span className="code">{period?.Cycle?.Code}</span> -{" "}
              <span className="range">{period?.Cycle?.Description}</span>
            </div>

            {period.Session.map((entry, i) => (
              <div key={i} className="entry-row">
                <div className="entry-date">{formatDate(entry.Date)}</div>
                <div className="entry-icon">
                  {statusMappingNames[entry?.Status]?.map((st, j) => (
                    <TauriImage
                      key={j}
                      localImage={statusIcon[st]}
                      alt={st}
                    />
                  ))}
                </div>
                <div className="entry-name">{entry.Account}</div>
              </div>
            ))}
            <div className="account-coverage-separator" />
          </div>
        ))
      )}
    </div>
  );
};

export default CoveragePeriod;
